// extracted by mini-css-extract-plugin
module.exports = {"AboutMe":"AboutMe_AboutMe__I_YCc"};